import { RECEIVE_QUESTIONS } from '../questions/actions'

export const viewedQuestions = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_QUESTIONS:
            return action.questions.map(q => q.id)

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/viewedQuestions/index.js